module.exports = __webpack_public_path__ + "img/游戏@2x.57fa9e26.png";